import React from 'react';
import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import ContaRepos from './conta/ContaRepos';

export default class Menu extends React.Component {
    render() {
        let catInv = [{id:'deptos',nombre:'Departamentos'},{id:'lineas',nombre:'Lineas'},{id:'subLineas',nombre:'SubLineas'},{id:'marcas',nombre:'Marcas'},{id:'agroquimicos',nombre:'Articulos'}];
        let movInv = [{id:'entRef',nombre:'Entradas'},{id:'salRef',nombre:'Salidas'},{id:'traspaso',nombre:'Traspasos'}];
        let conInv = [{id:'kardex',nombre:'kardex por almacen'},{id:'kardexGen',nombre:'Kardex general'}];
        let repInv = [{id:'rptLstEnt',nombre:'Listado de entradas'},{id:'rptLstSal',nombre:'Listado de salidas'},{id:'rptSdosAlm',nombre:'Saldos por almacen'},{id:'rptExis',nombre:'Existencia'},{id:'rptExisAct',nombre:'Existencia actual'},{id:'rptKardex',nombre:'Kardex'}];

        let movCompras = [{id:'requisicion',nombre:'Requisiciones'},{id:'cotiza',nombre:'Cotizaciones'},{id:'ordencompra',nombre:'Ordenes de compra'},{id:'compras',nombre:'Compras'}];

        let catCxp = [{id:'proveedores',nombre:'Proveedores'}];
        let movCxp = [{id:'xmls',nombre:'CFDI Recibidos'},{id:'cxpPagos',nombre:'Pago a proveedores'}];

        let catNom = [{id:'nomDeptos',nombre:'Departamentos'},{id:'sucursales',nombre:'Sucursales'}, {id:'empleados',nombre:'Empleados'}, {id:'actividadesNom',nombre:'Actividades'},{id:'actsCultivos',nombre:'Actividades por cultivo'}];
        let movNom = [{id:'capnom',nombre:'Registro de nomina'},{id:'capNomAg',nombre:'Actividades diarias'}];
        let conNom = [{id:'connom',nombre:'Nomina por empleado'}];
        
        let catConta = [{id:'contaCuenta',nombre:'Cuentas'},{id:'contaCostos',nombre:'Centros de costos'}];
        let movConta = [{id:'polizas',nombre:'Polizas'},{id:'cheques',nombre:'Cheques'},{id:'dividendos',nombre:'Retenciones de Dividendos'}];
        let repConta = [{id:'rptBalanza',nombre:'Balanza de comprobacion'},{id:'rptAnalitica',nombre:'Analitica de saldos'},{id:'rptAuxiliar',nombre:'Auxiliar'},{id:'rptVerificador',nombre:'Verificador de polizas'},{id:'rptPolizas',nombre:'Impresion de polizas'},{id:'rptBalance',nombre:'Balance General'},{id:'rptResultados',nombre:'Estado de resultados'}];

        let modulos = [
                       {id:"inv", nombre:"Inventario", catalogos:catInv, movimientos:movInv, consultas:conInv, reportes:repInv},
                       {id:"compras", nombre:"Compras", catalogos:[], movimientos:movCompras, consultas:[], reportes:[]},
                       {id:"vtas", nombre:"Ventas", catalogos:[], movimientos:[], consultas:[], reportes:[]},
                       {id:"cxc", nombre:"Clientes", catalogos:[], movimientos:[], consultas:[], reportes:[]},
                       {id:"cxp", nombre:"Proveedores", catalogos:catCxp, movimientos:movCxp, consultas:[], reportes:[]},
                       {id:"nom", nombre:"Nomina", catalogos:catNom, movimientos:movNom, consultas:conNom, reportes:[]},
                       {id:"conta", nombre:"Contabilidad", catalogos:catConta, movimientos:movConta, consultas:[], reportes:repConta}
                    ];
                    
        let config = {
          id:"conf", 
          nombre:"Configuracion", 
          opciones: [
            {id:'confUsuarios',nombre:'Usuarios'}
          ]
        };
    
        return (
            <ul className="nav">
                {modulos.map((e,i) =>{
                    return(
                        <li className="nav-item">
                            <Modulo modulo={e} opcionSeleccionada={this.props.opcionSeleccionada}/>
                        </li>    
                    )
                })}
                <ModuloSimple modulo={config} opcionSeleccionada={this.props.opcionSeleccionada}/>
            </ul>)
    }
}

class Modulo extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      popoverOpen: false
    };
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }
  onClick = (e) =>{
      this.toggle();
      //alert(e.target.dataset.opc);
      this.props.opcionSeleccionada(e.target.dataset.opc,e.target.innerText);
  }
  render() {
    const {modulo} = this.props;
    const titulo = modulo.nombre;
    const idMod = modulo.id;
    const catalogos = modulo.catalogos;
    const movimientos = modulo.movimientos;
    const consultas = modulo.consultas;
    const reportes = modulo.reportes;
    return (
      <div>
          <a  id={idMod} className="nav-link opcion" href="#">
          {titulo}
        </a>
        <Popover placement="bottom" isOpen={this.state.popoverOpen} target={idMod} toggle={this.toggle} trigger="legacy" style={{width:400}}>
          <PopoverBody >
              <div className="container" style={{padding:1}}>
                <div className="body" style={{padding:5}}>
                  <div className="row">
                      <div className="col">
                        <span><b>catalogos</b></span>
                        <ul>
                            {catalogos.map((e,i) => <li className="opcionMenu" data-opc={e.id} onClick={this.onClick}>{e.nombre}</li>)}
                        </ul>
                        <span><b>Movimientos</b></span>
                        <ul>
                            {movimientos.map((e,i) => <li data-opc={e.id} onClick={this.onClick}>{e.nombre}</li>)}
                        </ul>
                        <span><b>Consultas</b></span>
                        <ul>
                            {consultas.map((e,i) => <li data-opc={e.id} onClick={this.onClick}>{e.nombre}</li>)}
                        </ul>
                       </div>
                      <div className="col">
                        <span><b>Informes</b></span>
                        <ul>
                            {reportes.map((e,i) => <li data-opc={e.id} onClick={this.onClick}>{e.nombre}</li>)}
                        </ul>
                      </div>
                  </div>
                  </div>
              </div>
          </PopoverBody>
        </Popover>
      </div>
    );
  }
}

class ModuloSimple extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      popoverOpen: false
    };
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }
  onClick = (e) =>{
      this.toggle();
      //alert(e.target.dataset.opc);
      this.props.opcionSeleccionada(e.target.dataset.opc,e.target.innerText);
  }
  render() {
    const {modulo} = this.props;
    const titulo = modulo.nombre;
    const idMod = modulo.id;
    const opciones = modulo.opciones;
    return (
      <div>
          <a  id={idMod} className="nav-link opcion" href="#">
          {titulo}
        </a>
        <Popover placement="bottom" isOpen={this.state.popoverOpen} target={idMod} toggle={this.toggle} trigger="legacy" style={{width:400}}>
          <PopoverBody >
              <div className="container" style={{padding:1}}>
                <div className="body" style={{padding:5}}>
                  <div className="row">
                      <div className="col">
                        <ul>
                            {opciones.map((e,i) => <li data-opc={e.id} onClick={this.onClick}>{e.nombre}</li>)}
                        </ul>
                      </div>
                  </div>
                  </div>
              </div>
          </PopoverBody>
        </Popover>
      </div>
    );
  }
}